import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { BRAND, NAV } from "../mock/mock";
import { useContent } from "../context/ContentContext";
import { Button } from "./ui/button";

export default function Header() {
  const { brand = BRAND, nav = NAV } = useContent();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#0a0a0a]/95 backdrop-blur-md border-b border-[#B87333]/15" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between h-20 lg:h-24">
        <Link to="/" className="flex items-center gap-3 group">
          <img
            src={brand.logoUrl}
            alt="AR Danışmanlık"
            className="h-12 lg:h-14 w-auto object-contain transition-transform duration-500 group-hover:scale-[1.04]"
          />
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="text-[#f5ede1] font-serif-display text-lg lg:text-xl tracking-wide">
              AR DANIŞMANLIK A.Ş.
            </span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {nav.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `relative text-[12px] tracking-[0.25em] font-medium transition-colors duration-300 py-2 ${
                  isActive ? "text-[#B87333]" : "text-[#f5ede1] hover:text-[#D4A574]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  <span
                    className={`absolute left-0 -bottom-1 h-[1px] bg-[#B87333] transition-all duration-500 ${
                      isActive ? "w-full" : "w-0"
                    }`}
                  />
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href={`tel:${brand.phoneRaw}`}
            className="flex items-center gap-2 text-[#f5ede1] hover:text-[#B87333] text-sm tracking-wide transition-colors"
          >
            <Phone className="w-4 h-4" />
            <span className="font-sans-body">{brand.phone}</span>
          </a>
        </div>

        <button
          aria-label="Menu"
          className="lg:hidden text-[#f5ede1] p-2"
          onClick={() => setMobileOpen((v) => !v)}
        >
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-[#0a0a0a] border-t border-[#B87333]/15">
          <div className="px-6 py-6 flex flex-col gap-4">
            {nav.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `text-sm tracking-[0.25em] py-2 border-b border-[#B87333]/10 ${
                    isActive ? "text-[#B87333]" : "text-[#f5ede1]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Button
              asChild
              className="mt-3 bg-[#B87333] hover:bg-[#D4A574] text-[#0a0a0a] rounded-none tracking-widest text-xs"
            >
              <a href={`tel:${brand.phoneRaw}`}>{brand.phone}</a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
